import { clsx } from 'clsx';
import { FC } from 'react';
import { Body } from 'atoms/Typography/Typography';
import styles from './Discount.module.css';

export const Discount: FC<{
  discountPercentage: number;
  className?: string;
}> = ({ className, discountPercentage }) => {
  return !discountPercentage ? null : (
    <Body type="sm" className={clsx(styles.root, styles.discount, className)}>
      -{discountPercentage}%
    </Body>
  );
};
